import { ServerlessContractsPlugin } from './plugin/serverlessContractsPlugin';
export type { ServiceOptions as ServerlessContracts } from './types/serviceOptions';

module.exports = ServerlessContractsPlugin;
